const map = {
	"./config.b2ctest.json": 9909,
	"./config.local-b2ctest.json": 8503,
	"./config.local-prod.json": 6251,
	"./config.local-test.json": 4626,
	"./config.production.json": 1927,
	"./config.test.json": 1592
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5239;